import store from '@/store/store'; // eslint-disable-line

export default (router) => {
  router.beforeEach((to, from, next) => {
    next();

    const cardTwitter = document.querySelector('meta[name="twitter:image"]');
    const cardOg = document.querySelector('meta[property="og:image"]');

    if (to.name === 'index' || to.name === 'errorPage' || to.params.city === undefined) {
      document.title = store.state.seo.defaultTitle;
      cardTwitter.setAttribute('content', `https://conference.awwwards.com${store.state.seo.defaultCardUrl}`);
      cardOg.setAttribute('content', `https://conference.awwwards.com${store.state.seo.defaultCardUrl}`);
      next();
    } else {
      document.title = store.state.seo[to.params.city].title;
      cardTwitter.setAttribute('content', `https://conference.awwwards.com${store.state.seo[to.params.city].cardUrl}`);
      cardOg.setAttribute('content', `https://conference.awwwards.com${store.state.seo[to.params.city].cardUrl}`);
    }

    // const { type } = to.matched[0].props.default;
    // const routeParams = to.params;
    // switch (true) {
    //   case type === 'page':
    //     store.dispatch('LOAD_PAGE', {
    //       city: routeParams.city,
    //       page: to.name,
    //     });
    //     break;

    //   case type === 'child':
    //     store.dispatch('LOAD_CHILD', {
    //       father: `${to.name}s`,
    //       city: routeParams.city,
    //       type: to.name,
    //       id: routeParams[to.name],
    //     });
    //     break;

    //   default:
    //     break;
    // }
  });
};
